import { z } from 'zod';

export const tinkoffStatusSchema = z.enum([
    'NEW',
    'FORM_SHOWED',
    'AUTHORIZING',
    '3DS_CHECKING',
    '3DS_CHECKED',
    'AUTHORIZED',
    'CONFIRMING',
    'CONFIRMED',
    'REVERSING',
    'PARTIAL_REVERSED',
    'REVERSED',
    'REFUNDING',
    'PARTIAL_REFUNDED',
    'REFUNDED',
    'CANCELED',
    'DEADLINE_EXPIRED',
    'REJECTED',
    'AUTH_FAIL',
]);

export type TinkoffStatusSchema = z.infer<typeof tinkoffStatusSchema>;
